export default "\r\n<app-frequency-list></app-frequency-list>\r\n\r\n\r\n";